module.exports = __webpack_public_path__ + "img/product-banner_3.b760e758.png";